import type {AxiosRequestConfig} from 'axios';
import {Warehouse, InventoryItems, Status} from './interface';

export class DeleteWarehouseBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };
  id(id: number) {
    this.warehouseRequest.url = `/warehouses/${id}`;
    return this;
  }
  build() {
    return this.warehouseRequest;
  }
}
export class GetAllWarehousesRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/warehouses',
    params: {},
  };

  id(id: number) {
    this.warehouseRequest.url = `/warehouses/${id}`;
    return this;
  }
  params(params: object) {
    this.warehouseRequest.params = params;
    return this;
  }

  build() {
    return this.warehouseRequest;
  }
}
export class GetWarehousesCountRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/warehouses/count',
    params: {},
  };
  params(params: object) {
    this.warehouseRequest.params = params;
    return this;
  }

  build() {
    return this.warehouseRequest;
  }
}

export class GetWarehouseInventoriesRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/warehouse-inventory',
    params: {},
  };

  params(params: object) {
    this.warehouseRequest.params = params;
    return this;
  }

  build() {
    return this.warehouseRequest;
  }
}

export class UpdateWarehouseInventoryRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/warehouse-inventory',
    data: {},
  };
  data(body: object) {
    this.warehouseRequest.data = body;
    return this;
  }
  build() {
    return this.warehouseRequest;
  }
}

export class UpdateWarehouseInventoriesRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/warehouse-inventory/batch',
    data: {},
  };
  data(body: object) {
    this.warehouseRequest.data = body;
    return this;
  }
  build() {
    return this.warehouseRequest;
  }
}

export class UpdateExcelWarehouseInventoriesRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/warehouse-inventory/upload',
    data: {},
  };
  data(body: object) {
    this.warehouseRequest.data = body;
    return this;
  }
  id(id: number) {
    this.warehouseRequest.url = `/warehouse-inventory/upload/${id}`;
    return this;
  }
  build() {
    return this.warehouseRequest;
  }
}

export class GetWarehousesInventoryRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/warehouses/inventory',
    params: {},
  };

  id(id: number) {
    this.warehouseRequest.url = `/warehouses/${id}/inventory`;
    return this;
  }
  params(params: object) {
    this.warehouseRequest.params = params;
    return this;
  }

  build() {
    return this.warehouseRequest;
  }
}

export class GetWarehouseOperatorsRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/warehouses/operators',
    params: {},
  };

  params(params: object) {
    this.warehouseRequest.params = params;
    return this;
  }

  build() {
    return this.warehouseRequest;
  }
}

export class CreateWarehousesRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/warehouses',
    data: {},
  };

  data(data: Warehouse) {
    this.warehouseRequest.data = data;
    return this;
  }

  build() {
    return this.warehouseRequest;
  }
}

export class UpdateWarehouseRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/warehouses',
    data: {},
  };
  id(id: number) {
    this.warehouseRequest.url = `/warehouses/${id}/admin`;
    return this;
  }
  data(body: Warehouse | number) {
    this.warehouseRequest.data = body;
    return this;
  }
  build() {
    return this.warehouseRequest;
  }
}

export class UpdateWarehouseStatusRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };
  id(id: number) {
    this.orderRequest.url = `/warehouses/${id}/status`;
    return this;
  }
  data(body: Status) {
    this.orderRequest.data = `"${body}"`;
    return this;
  }
  build() {
    return this.orderRequest;
  }
}

export class GetAllInventoryItemsRequestBuilder {
  // Todo : Change this route
  private readonly inventoryItemsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/inventory-items',
    params: {},
  };

  id(id: number) {
    this.inventoryItemsRequest.url = `/inventory-items/${id}`;
    return this;
  }
  params(params: object) {
    this.inventoryItemsRequest.params = params;
    return this;
  }

  build() {
    return this.inventoryItemsRequest;
  }
}
export class GetAllInventoryItems {
  // Todo : Change this route
  private readonly inventoryItemsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/inventory-items',
    params: {},
  };
  params(params: object) {
    this.inventoryItemsRequest.params = params;
    return this;
  }

  build() {
    return this.inventoryItemsRequest;
  }
}

export class GetInventoryItemsCountRequestBuilder {
  private readonly inventoryItemsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/inventory-items/count',
    params: {},
  };
  params(params: object) {
    this.inventoryItemsRequest.params = params;
    return this;
  }

  build() {
    return this.inventoryItemsRequest;
  }
}

export class CreateInventoryItemRequestBuilder {
  private readonly InventoryItemsRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/inventory-items',
    data: {},
  };

  data(data: InventoryItems) {
    this.InventoryItemsRequest.data = data;
    return this;
  }

  build() {
    return this.InventoryItemsRequest;
  }
}

export class GetWarehousesChildrenRequestBuilder {
  private readonly warehouseRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/warehouses',
    params: {},
  };

  id(id: number) {
    this.warehouseRequest.url = `/warehouses/${id}/children`;
    return this;
  }
  params(params: object) {
    this.warehouseRequest.params = params;
    return this;
  }

  build() {
    return this.warehouseRequest;
  }
}
